module.exports = __webpack_public_path__ + "img/document.a8f435af.svg";